__webpack_require__.p = "https://bc-cp-fe.securitize.io/";